import update from 'immutability-helper';
import axios from 'axios';
import I18n from '../locale';
import qwTheatreACL from '../common/client/qwTheatreAccessControlList';
import { displayError } from './app';

const initialState = {
  users: [],
  offset: 0,
  ps: 15,
  loading: false,
  hasMore: false,
  userCount: 0,
  companyName: '',
  error: false,
};

const SET_ALL_USERS = 'users/SET_ALL_USERS';
const SET_LOADING = 'users/SET_LOADING';
const SET_HAS_MORE = 'users/SET_HAS_MORE';
const SET_OFFSET = 'users/SET_OFFSET';
const SET_COMPANY_NAME = 'users/SET_COMPANY_NAME';
const SET_USER_COUNT = 'users/SET_USER_COUNT';
const SET_ERROR = 'users/SET_ERROR';

function setUsers(users) {
  return {
    type: SET_ALL_USERS,
    payload: users,
  };
}

function setHasMore(hasMore) {
  return {
    type: SET_HAS_MORE,
    payload: hasMore,
  };
}

function setLoading(hasMore) {
  return {
    type: SET_LOADING,
    payload: hasMore,
  };
}

function setOffset(offset) {
  return {
    type: SET_OFFSET,
    payload: offset,
  };
}

function setCompanyName(company) {
  return {
    type: SET_COMPANY_NAME,
    payload: company,
  };
}

function setUserCount(userCount) {
  return {
    type: SET_USER_COUNT,
    payload: userCount,
  };
}

function setError(error) {
  return {
    type: SET_ERROR,
    payload: error,
  };
}

const { CancelToken } = axios;
let source = CancelToken.source();

export function fetchUsers(
  offset = 0,
  { ps, columnToSort, sortDirection, query, filterRoles, filterGroups } = {},
) {
  return (dispatch) => {
    dispatch(setLoading(true));
    dispatch(setError(false));
    if (source) {
      source.cancel();
      source = CancelToken.source();
    }
    qwTheatreACL
      .get('/v1/users', {
        cancelToken: source.token,
        params: {
          ps: ps || initialState.ps,
          offset,
          sortBy: columnToSort,
          sortDir: sortDirection,
          q: query?.length ? query : undefined,
          filterRoles,
          filterGroups,
          excludeInactiveUsers: true,
          userGroupOnly: true,
        },
      })
      .then((response) => {
        dispatch(setUsers(response.data.users));
        dispatch(setHasMore(response.data.hasMore));
        dispatch(setUserCount(response.data.userCount));
        dispatch(setOffset(offset));
        dispatch(setLoading(false));
      })
      .catch((error) => {
        if (!axios.isCancel(error)) {
          dispatch(displayError(I18n.t('errorFetchingUsersList')));
          dispatch(setUsers({}));
          dispatch(setError(true));
          dispatch(setLoading(false));
        }
      });
  };
}

export function fetchUsersForAdmin(
  offset = 0,
  {
    ps,
    columnToSort,
    sortDirection,
    query,
    filterRoles,
    filterGroups,
    companyId,
  } = {},
) {
  return (dispatch) => {
    dispatch(setLoading(true));
    dispatch(setError(false));
    if (source) {
      source.cancel();
      source = CancelToken.source();
    }
    qwTheatreACL
      .get(`/v1/admin/company/${companyId}/users`, {
        cancelToken: source.token,
        params: {
          ps: ps || initialState.ps,
          offset,
          sortBy: columnToSort,
          sortDir: sortDirection,
          q: query?.length ? query : undefined,
          filterRoles,
          filterGroups,
        },
      })
      .then((response) => {
        dispatch(setUsers(response.data.users));
        dispatch(setCompanyName(response.data.displayName));
        dispatch(setHasMore(response.data.hasMore));
        dispatch(setOffset(offset));
        dispatch(setUserCount(response.data.userCount));
      })
      .catch(() => {
        dispatch(displayError(I18n.t('errorFetchingUsersList')));
        dispatch(setUsers({}));
        dispatch(setError(true));
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_ALL_USERS:
      return update(state, { users: { $set: action.payload } });
    case SET_LOADING:
      return update(state, { loading: { $set: action.payload } });
    case SET_HAS_MORE:
      return update(state, { hasMore: { $set: action.payload } });
    case SET_OFFSET:
      return update(state, { offset: { $set: action.payload } });
    case SET_COMPANY_NAME:
      return update(state, { companyName: { $set: action.payload } });
    case SET_USER_COUNT:
      return update(state, { userCount: { $set: action.payload } });
    case SET_ERROR:
      return update(state, { error: { $set: action.payload } });
    default:
      return state;
  }
}
